import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Title from "../../components/common/title/Title";
import ExportExcel from "../../components/common/export-exel/ExportExel";
import { getApi } from "../../services/api/globalApi";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import DateOnlyInput from "../../components/common/inputs/DateOnlyInput";

export default function OrderStatistics() {
  const { utils } = useSelector(utilsState);
  const [filters, setFilters] = useState({ from: "", to: "", role: "" });
  const [count, setCount] = useState(null);
  const [processingCount, setProcessingCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async (params) => {
    setLoading(true);
    setError("");
    try {
      const [orders, processing] = await Promise.all([
        getApi({ path: "admin/reports/totalOrdersCount", params }),
        getApi({ path: "admin/reports/totalProccessingOrdersCount" }),
      ]);
      setCount(orders.data.result);
      setProcessingCount(processing.data.result);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || "دریافت آمار انجام نشد.");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load({}); }, [load]);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Title title="آمار تعداد سفارش‌ها" />
        <ExportExcel jsonData={[{ "تعداد سفارش‌های پرداخت‌شده": count ?? "", "سفارش‌های در انتظار تأیید ارسال (کل)": processingCount ?? "" }]} />
      </div>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        تعداد سفارش‌های پرداخت‌شده را بر اساس تاریخ پرداخت و نقش کاربر نشان می‌دهد. تعداد سفارش‌های در انتظار تأیید ارسال، آمار کل است و به فیلترها وابسته نیست.
      </p>
      <form onSubmit={(event) => { event.preventDefault(); load(filters); }} className="flex flex-wrap items-end gap-3">
        <DateOnlyInput name="order-statistics-from" label="از تاریخ پرداخت" value={filters.from} onChange={(from) => setFilters((previous) => ({ ...previous, from }))} />
        <DateOnlyInput name="order-statistics-to" label="تا تاریخ پرداخت" value={filters.to} onChange={(to) => setFilters((previous) => ({ ...previous, to }))} />
        <label className="flex flex-col gap-1 text-sm dark:text-white">نقش کاربر
          <select value={filters.role} onChange={(event) => setFilters({ ...filters, role: event.target.value })} className="admin-field">
            <option value="">همه</option>
            {utils?.ROLES_VALUES?.map((item) => <option key={item.value} value={item.value}>{item.name}</option>)}
          </select>
        </label>
        <button type="submit" disabled={loading} className="rounded-lg bg-blue-700 text-white px-4 py-2 disabled:opacity-50">نمایش آمار</button>
      </form>
      {error && <p role="alert" className="text-red-600">{error}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 dark:text-white">
        <div className="rounded-xl bg-blue-50 dark:bg-blue-950 p-5"><p>سفارش‌های پرداخت‌شده</p><strong className="text-2xl">{count ?? "—"}</strong></div>
        <div className="rounded-xl bg-amber-50 dark:bg-amber-950 p-5"><p>در انتظار تأیید ارسال (کل)</p><strong className="text-2xl">{processingCount ?? "—"}</strong></div>
      </div>
    </div>
  );
}
